"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLabel = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M14.6916667,4.86666667 C14.3916667,4.44166667 13.8916667,4.16666667 13.3333333,4.16666667 L4.16666667,4.175 C3.25,4.175 2.5,4.91666667 2.5,5.83333333 L2.5,14.1666667 C2.5,15.0833333 3.25,15.825 4.16666667,15.825 L13.3333333,15.8333333 C13.8916667,15.8333333 14.3916667,15.5583333 14.6916667,15.1333333 L18.3333333,10 L14.6916667,4.86666667 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconLabel')(IconLabel);